import { Notification } from './types'

export interface IUiNotificationsState {
  notifications: Notification[]
}

export default (): IUiNotificationsState => ({
  notifications: [],
})
